import { useState, useEffect } from "react";
import { ChevronDown, Phone, Mail, Menu, X } from "lucide-react";
import logo from "../../Images/logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function Navbar() {
  const [openMenu, setOpenMenu] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  // Close dropdown when mobile menu closes
  useEffect(() => {
    if (!mobileMenuOpen) setOpenMenu(null);
  }, [mobileMenuOpen]);
const handleLogoClick = (e) => {
    // If already on homepage, just scroll to top
    if (location.pathname === "/") {
      e.preventDefault(); // stop Link navigation
      window.scrollTo({ top: 0, behavior: "smooth" });
      setMobileMenuOpen(false);
      setOpenMenu(null);
    } else {
      // If on another page, go home normally
      setMobileMenuOpen(false);
      setOpenMenu(null);
      navigate("/");
    }
  };
  const menuItem = (label, items) => (
    <div
      className="w-full md:w-auto relative"
      onMouseEnter={() => !mobileMenuOpen && setOpenMenu(label)}
      onMouseLeave={() => !mobileMenuOpen && setOpenMenu(null)}
    >
      {/* Trigger */}
      <button
        onClick={() =>
          mobileMenuOpen && setOpenMenu(openMenu === label ? null : label)
        }
        className="flex w-full md:w-auto items-center justify-between md:justify-start gap-2
        py-3 md:py-2 font-medium text-gray-700 hover:text-gray-900"
      >
        {label}
        <ChevronDown
          size={16}
          className={`transition ${openMenu === label ? "rotate-180" : ""}`}
        />
      </button>

      {/* Dropdown */}
      <div
        className={`w-full md:absolute md:left-0 md:top-full  md:w-48
        bg-gray-50 md:bg-white rounded-xl md:shadow-lg md:border
        overflow-hidden transition-all duration-300
        ${
          openMenu === label
            ? "max-h-96 opacity-100"
            : "max-h-0 opacity-0 md:max-h-none md:opacity-100 md:hidden"
        }`}
      >
        {items.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            onClick={() => {
              setMobileMenuOpen(false);
              setOpenMenu(null);
            }}
            className="block w-full px-4 py-3 text-sm text-gray-600
      border-b last:border-b-0 hover:bg-gray-100 md:hover:bg-gray-50"
          >
            {item.label}
          </Link>
        ))}
      </div>
    </div>
  );
  const mainLinks = [
    { label: "Kontakt", path: "/kontak" },
    { label: "Karriere", path: "/karriere" },
    { label: "Über uns", path: "/ueber-uns" },
    { label: "Ratgeber", path: "/ratgeber" },
    { label: "Angebot einholen", path: "/unverbindliches-angebot" },
    // { label: "Login", path: "/login" },
  ];

  return (
    <nav
      className="fixed top-4 left-1/2 -translate-x-1/2 w-[90%] 2xl:w-[70%]
    bg-white shadow-sm z-50 rounded-2xl md:rounded-full"
    >
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" onClick={handleLogoClick}>
          <img src={logo} alt="Logo" className="h-8 w-auto " />
        </Link>

        {/* Mobile Hamburger */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="md:hidden p-2 rounded-full border hover:bg-gray-50"
        >
          {mobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
        </button>

        {/* Menu */}
        <div
          className={`absolute mt-[-13px] md:mt-0 md:static top-full left-0 w-full md:w-auto
  bg-white md:bg-transparent rounded-b-2xl md:rounded-none
  shadow-md md:shadow-none transition-all duration-300
  ${mobileMenuOpen ? "block" : "hidden"} md:flex
  flex-col md:flex-row md:flex-nowrap items-start md:items-center gap-0 md:gap-6
  px-6 py-4 md:p-0`}
        >
          <Link
            to="/"
            className="block md:inline-block md:w-auto whitespace-nowrap py-3 md:py-2
    border-b md:border-none last:border-b-0 font-medium text-gray-700 hover:text-gray-900"
          >
            Startseite
          </Link>

          {menuItem("Leistungen", [
            // { label: "Bewertung Löschen", path: "/bewertung-loeschen" },
            { label: "Web-Design", path: "/webdesign-agentur-bremen" },
            { label: "Local Listing", path: "/local-listing-optimierung" },
            { label: "Ki-Automation", path: "/ki-automatisierung-prozesse" },
          ])}

          {mainLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setMobileMenuOpen(false)}
              className="block md:inline-block md:w-auto whitespace-nowrap py-3 md:py-2
      border-b md:border-none last:border-b-0 font-medium text-gray-700 hover:text-gray-900"
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Actions (desktop only) */}
        <div className="hidden md:flex items-center gap-3">
          {/* Phone */}
          <a
            href="tel:+4942136583008"
            aria-label="Call UNEVA"
            className="p-2 rounded-full border hover:bg-gray-50 transition"
          >
            <Phone size={18} />
          </a>

          {/* Email */}
          <a
            href="mailto:anfrage@uneva.de"
            aria-label="Email UNEVA"
            className="p-2 rounded-full border hover:bg-gray-50 transition"
          >
            <Mail size={18} />
          </a>
        </div>
      </div>
    </nav>
  );
}
